import Menu from '@/global/components/MenuV2'
import { FormField } from 'global/components/Form'

interface IProps {
    required?: boolean
}

export function SelectTipoDocumento({ required }: IProps) {
    return (
        <FormField
            required={required}
            select
            name="tipoDocumento"
            label="Tipo de documento"
        >
            <Menu.Item value={'CNPJ'}>CNPJ</Menu.Item>
            <Menu.Item value={'CAEPF'}>CAEPF</Menu.Item>
            <Menu.Item value={'CPF'}>CPF</Menu.Item>
        </FormField>
    )
}
